import { datadog } from "@/platform/observability/datadog/facade"
import { claimError, errorFacts } from "@/platform/observability/errors"
import { recordTelemetry } from "@/platform/observability/telemetry"

import type { Logger } from "./types"

export const createClientLogger = (): Logger => ({
  info: (message, context) => {
    recordTelemetry(() => datadog.logInfo(message, context))
  },

  warn: (message, context, error) => {
    recordTelemetry(() => datadog.logWarn(message, context, error instanceof Error ? error : undefined))
  },

  error: (message, context, error) => {
    recordTelemetry(() => {
      if (!claimError(error)) return
      const errorInstance = error instanceof Error ? error : new Error(message, { cause: error })
      datadog.logError(message, { ...context, ...errorFacts(error) }, errorInstance)
      datadog.addError(errorInstance, { type: message, ...context, ...errorFacts(error) })
    })
  },
})

export const logger: Logger = createClientLogger()
